import { Component, Injector, OnInit, inject, viewChild } from '@angular/core';
import {
  idNameItem,
  jkAlert,
  JkBaseOption,
  jkLib,
  MaterialModule,
} from 'jk-service';
import { StkleService, StklgService, StkmaService } from '../_service_stk';
import { StockService } from '../services/stock.service';
import { JkbbchartComponent } from '../components/jkbbchart/jkbbchart.component';
import { RowDoubleClickedEvent } from 'ag-grid-community';
import { AdvComModule, jkQueryComponent } from 'jk-advcom';
import { Stkle } from '../_entity_stk';
import { JackBaseComponentModule } from 'jk-service';
import { JkbtneditComponent, JkmultiselectComponent, JkrangeComponent } from 'jk-advcom';

class PageOption extends JkBaseOption {
  // ###
}

class FilterOption extends JkBaseOption {
  // ###
  rgDateA: string;
  rgDateB: string;
  stockNo: string = '';
  order: string = '';
  constructor(programId: string) {
    super(programId);
    this.rgDateA = jkLib.countDate(jkLib.nowDate(), 'D', -1);
    this.rgDateB = jkLib.nowDate();
  }
}

@Component({
  selector: 'app-stkpq10',
  templateUrl: './stkpq10.component.html',
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, JkbbchartComponent, MaterialModule, AdvComModule],
})
export class Stkpq10Page extends jkQueryComponent implements OnInit {
  override _programId = 'stkpq10'; // ###
  readonly stkle001 = viewChild.required<JkrangeComponent>('stkle001');
  readonly stkle003 = viewChild.required<JkbtneditComponent>('stkle003');
  readonly stkle010Com = viewChild.required<JkmultiselectComponent>('stkle010Com');
  pageOpt: PageOption = new PageOption(this.programId + '_page'); //###
  filterOpt: FilterOption = new FilterOption(this.programId); //###
  //qryMaster: StkleService = new StkleService();//###
  orderList: idNameItem[] = [{ id: 'ORDER BY TM002', name: '商品代號' }]; // [{'id':'ORDER BY LG001,LG002,LG003,LG004','name':'日期順序'},{'id':'ORDER BY LG001 DESC,LG002 DESC,LG003 DESC,LG004 DESC','name':'日期倒序'}];
  //stockHost: string ='http://localhost:9086';
  //hostList: idNameItem[] = [{id:'http://localhost:9086',name:'本機'},{id:'http://jk-ubun:9086',name:'虛擬機jk-ubun'}];
  //stkma001List: idNameItem[] = [];
  //itemDeleteMode: ItemDeleteMode = 'toggle'; // 'static','toggle','slideButton','slideItem',  'swipe',  'context'
  stkleSrv: StkleService = new StkleService();
  stkle010: idNameItem[] = [];
  constructor() {
    super();
    this.setFormOpt2(); //###
    //this.filterOpt = new FilterOption(this.programId);//###
    //this.pageOpt = new PageOption(this.programId + '_page');//###
    this.logMessage = '無錯誤訊息';
  }

  override ngOnInit() {
    super.ngOnInit();
    //this.filterOpt.load();//###
    //this.pageOpt.load();//###
    //this.stkma001List = await jkOpenWin.doOpenWin<idNameItem[]>('S','#STKMA001','V01',[]);
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    //this.masterGridSet.init(this.masterGrid, this.qryMaster);
    //this.detailGridSet.init(this.detailGrid, this.qryDetail as JkEntity);
    this.titlebarCom.onUser1Click = this.doRefresh;
    this.titlebarCom.user1Text = '重新顯示';
    //this.stkle001.valueA = jkLib.countDate(jkLib.nowDate(),'D',-1);
    //this.stkle001.valueB = jkLib.nowDate();

    try {
      //await this.masterLookup.init();
    } catch (error) { }
    this.checkAllInit(this); // 這行要放在 ngAfterViewInit 最後  ###
    await this.doQuery();
  }

  override async beforeQuery(): Promise<boolean> {
    await super.beforeQuery();
    try {
      //await this.gridMain.init('STKPQ10','S01','S',['LE001','LE002','LE011'],[]);
      this.type = 'S';
      this.winItem = 'S01';
      this.mainTable = this.programId; //['LG001','LG002','LG003','LG004'];
      this.where = '';
      this.where = this.stkle001().addWhere(this.where, 'LE001');
      this.where = this.stkle003().addWhere(this.where, 'LE003');
      this.where = this.stkle010Com().addWhere(this.where, 'LE010');
    } catch (error: any) {
      this.logMessage = JSON.stringify(error);
      return false;
    }

    return true;
  }

  // ### [以上是必要的]================================
  async delete(item: Stkle) {
    if (!confirm('確定要刪除嗎?')) return;
    // TODO: 這裡要寫刪除的程式
    let sql = `DELETE FROM STKLE WHERE LE001='${item.LE001}' AND LE002='${item.LE002}' AND LE011='${item.LE011}'`;
    let ret = await this.orm.transactionOneSql(sql);
    if (!ret.result) {
      alert('刪除失敗:' + ret.errorLog);
      return;
    }
    /*
    let it = this.gridMain.itemList.findIndex(x=>x.LE001===item.LE001 && x.LE002===item.LE002 && x.LE011===item.LE011);
    if(it>=0){

      await this.stkleSrv.deleteByItem(this.gridMain.itemList[it]);

      this.gridMain.itemList.splice(it,1);
      alert('刪除成功:'+item.LE001+'-'+item.LE002+'-'+item.LE011);
    }*/
    //this.resort();
    this.doQuery();
  }
  async doReadOk(item: Stkle) {
    if (!confirm('確定要已讀嗎?')) {
      alert('取消已讀:' + item.LE008);
      if (item.LE008 === 'Y') item.LE008 = 'N';
      else item.LE008 = 'Y';
      return;
    }
    // TODO: 這裡要寫已讀的程式
    let key = this.stkleSrv.getKeyValues(item);
    await this.stkleSrv.updateData(key, item);
  }
  async onItemDeleting($event: any) {
    debugger;
    let item = $event.detail.item as Stkle;
    await this.delete(item);
  }
  doDelete2() {
    let sqlDelete = `DELETE FROM STKLE `;
    this.where = ` WHERE 1=1 `;
    this.where = this.stkle001().addWhere(this.where, 'LE001');
    this.where = this.stkle003().addWhere(this.where, 'LE003');
    this.where = this.stkle010Com().addWhere(this.where, 'LE010');

    this.orm.simpleSql(this.host, sqlDelete + this.where).subscribe((ret: any) => {
      if (ret.error) {
        jkAlert(ret.error);
        return;
      }
      this.showToast('刪除成功');
      this.doQuery();
    });
  }
  doSetDefine(type: number) {
    //this.stkle010Com.values = [];
    let s = this.stkleSrv.le010Filter(type);
    let list = jkLib.string2IdNameItem(s, ',');
    //this.stkle010Com.values = list;
    this.stkle010Com().onValuesChange(list);
  }
  isGridTileVisible: boolean = false;
  //gridTileCols: number = 2;
  toggleGridTile(): void {
    this.isGridTileVisible = !this.isGridTileVisible;
    //if (this.isGridTileVisible) this.gridTileCols = 2;
    //else this.gridTileCols = 1;
  }
  stockSrv: StockService = new StockService();
  stklgSrv: StklgService = new StklgService();
  stkmaSrv: StkmaService = new StkmaService();
  _stockno: string = '';
  get stockno(): string {
    return this._stockno;
  }
  set stockno(value: string) {
    this._stockno = value;
  }
  stocknoChange($event: string) {
    this.stockno = $event;
  }
  gridDoubleClick($event: RowDoubleClickedEvent<any, any>) {
    this.stockno = $event.data.LE003;
  }
}
